import EF from 'ef/ef';
import Backbone from 'backbone';
import ActivityProgress from 'ef/models/activity_progress';
import _ from 'lodash';

/* ### EF.Collections.ActivityProgressesCollection
//
// Responsible for managing enrollment's ActivityProgress objects.
// Include slug option to filter by activity slug.
//
// Example use-case: viewing an enrollment's assessment results
// for Everfi Post Assessment
//
// EF.postAssessmentResults = new ActivityProgressesCollection([], {
//    enrollment: EF.enrollment,
//    slug: POST_ASSESSMENT_SLUG
// });
//
// Fetch results from server:
// EF.postAssessmentResults.fetch().done(function () {
//   // Get the highest graded result:
//   EF.postAssessmentResults.highestGrade();
// });
/*/
const ActivityProgressesCollection = Backbone.Collection.extend({
  model: ActivityProgress,
  fileName: 'activity_progresses.json',

  sync: function (method, model, options) {
    if (method === 'read') {
      return Backbone.sync(method, model, options);
    } else {
      throw new Error('Model is read only');
    }
  },

  initialize: function (models, options) {
    options = options || {};
    this.enrollment = options.enrollment || EF.enrollment;
    this.slug = options.slug;
    this.on('add', this.handleAdd);
  },

  url: function () {
    const id = this.enrollment.get('id');
    let rootUrl = `/sdk/enrollments/${id}/${this.fileName}`;
    if (this.slug) {
      rootUrl += `?activity_slug=${this.slug}`;
    }
    return EF.url(rootUrl);
  },

  handleAdd: function (ap) {
    ap.enrollment = this.enrollment;
  },

  orderBy: function (key) {
    return _.sortBy(this.models, function (m) {
      return m.get(key);
    });
  },

  highestGrade: function () {
    return _.last(this.orderBy('grade'));
  },

  mostRecent: function () {
    return _.last(this.orderBy('created_at'));
  },

  bySlug: function (slug) {
    return this.filter(function (ap) {
      return ap.get('slug') === slug;
    });
  },

  byModuleKey: function (moduleKey) {
    return this.filter(function (ap) {
      return ap.get('module_key') === moduleKey;
    });
  },

  highestGradeByModuleKey: function (moduleKey) {
    return _.last(
      _.sortBy(this.byModuleKey(moduleKey), function (m) {
        return m.get('grade');
      })
    );
  },

  highestGradeBySlug: function (slug) {
    return _.last(
      _.sortBy(this.bySlug(slug), function (m) {
        return m.get('grade');
      })
    );
  },
});

export default ActivityProgressesCollection;
